define('app/views/business_contact_form_view',['app/setup'], function(takhfifan) {

  takhfifan.businessContactFormView = Backbone.View.extend({

    events: {
      'click #tkhBusinessFormSubmit': 'submit'
    },

    initialize: function(options) {
      Backbone.Validation.bind(this);
    },
    submit: function(evt) {
      this.model.set(takhfifan.Helper.serializeToObject(this,'name'), { validate: true });
      if(this.model.isValid()) {
        this.$el.submit();
      }
    }

  });

});

